<template>
    <div class="animated fadeIn dashboard-produccion">
      <b-row>
        <b-col sm="12" lg="12">
          <div class="dashboard-tabla-resultados">
            <div class="dashboard-tabla-resultados-header">
              <h4>Compras x Proveedor</h4>
              <p class="description">Últimos 12 meses</p>
              <p class="description">Incluye facturación de órdenes a proveedores y remitos asociados a presupuestos</p>
              <!-- <p class="description">Incluye gastos de la cuenta Producción</p> -->
            </div>
            <div class="dashboard-tabla-resultados-data">
              <b-table hover
                  responsive="sm" 
                  class="table-dashboard compras"
                  :busy="tableBusy"
                  :items="proveedores" 
                  :fields="proveedoresFields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(montoNeto)="data">
                  {{ data.item.montoNeto | moneda }}
                </template>
                <template v-slot:cell(plazoPago)="data">
                  {{ data.item.plazoPago | numero(2, true) }}
                </template>
                <template v-slot:cell(ordenes-remitos)="data">
                  {{ data.item.ordenesProveedores + data.item.remitos }}
                </template>
                <template v-slot:cell(porcentaje)="data">
                  {{ data.item.porcentaje | porcentaje }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <template v-if="data.item.proveedorId != -1">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click.stop="consultarCompras(data.item.proveedorId)">
                        <i class="fa fa-file-excel-o"></i>Exportar Compras</b-dropdown-item>
                    </b-dropdown>
                  </template>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="12" lg="12">
          <div class="dashboard-tabla-resultados">
            <div class="dashboard-tabla-resultados-header">
              <h4>Gastos x Proveedor</h4>
              <p class="description">Últimos 12 meses</p>
              <p class="description">Incluye facturación de órdenes a proveedores y remitos internos</p>
              <!-- <p class="description">No incluye gastos de la cuenta Producción</p> -->
            </div>
            <div class="dashboard-tabla-resultados-data">
              <b-table hover
                  responsive="sm" 
                  class="table-dashboard gastos"
                  :busy="tableBusy"
                  :items="proveedoresGastos" 
                  :fields="proveedoresGastosFields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(montoNeto)="data">
                  {{ data.item.montoNeto | moneda }}
                </template>
                <template v-slot:cell(plazoPago)="data">
                  {{ data.item.plazoPago | numero(2, true) }}
                </template>
                <template v-slot:cell(ordenes-remitos)="data">
                  {{ data.item.ordenesProveedores + data.item.remitos }}
                </template>
                <template v-slot:cell(porcentaje)="data">
                  {{ data.item.porcentaje | porcentaje }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <template v-if="data.item.proveedorId != -1">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click.stop="consultarGastos(data.item.proveedorId)">
                        <i class="fa fa-file-excel-o"></i>Exportar Gastos</b-dropdown-item>
                    </b-dropdown>
                  </template>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>
      </b-row>

      <hr class="dashboard">

      <b-row>
        <b-col sm="5" lg="5">
          <div class="dashboard-chart">
            <h4>Ordenes x Proveedor</h4>
            <p class="description">Últimos 12 meses</p>
            <ranking-ordenes ref="rankingOrdenes"></ranking-ordenes>
            <label class="description">Ranking por Cantidad de Ordenes Emitidas</label>
            <label class="description">Excluye proveedores eventuales</label>
          </div>
        </b-col>
        <b-col sm="7" lg="7">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="resultadosOrdenesProveedores" 
              :fields="resultadosOrdenesProveedoresFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(color)="data">
                <div class="color-reference" :style='"background-color: " + getColor(data.item) + ";"'></div>              
            </template>
            <template v-slot:cell(pjeParticipacion)="data">
              {{ data.item.pjeParticipacion | porcentaje }}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- <app-presupuestos-proveedores
        v-if="accesoRankingPresupuestos"
        ref="rankingPresupuestosProveedores">
      </app-presupuestos-proveedores> -->

      <hr class="dashboard">

      <b-row>
        <b-col sm="6" lg="4">
          <app-indicador-rentabilidad-ordenes
            ref="indicadorRentabilidadOrdenes">
          </app-indicador-rentabilidad-ordenes>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import Pie from '../charts/Pie';
import RankingOrdenes from '../charts/Pie';
// import PresupuestosProveedores from './produccion/PresupuestosProveedores';
import IndicadorRentabilidadOrdenes from './IndicadorRentabilidadOrdenes';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import export_xls_compras from '../../mixins/export_xls_compras';

export default {
  components: {
    Pie,
    RankingOrdenes,
    // appPresupuestosProveedores: PresupuestosProveedores,
    appIndicadorRentabilidadOrdenes: IndicadorRentabilidadOrdenes,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal,
    export_xls_compras 
  ],

data() {
    return {
      key: 0,
      tableBusy: false,
      proveedores: [],
      proveedoresFields: [
        // { 
        //   key: 'color',
        //   label: 'Ref'
        // },
        { key: 'proveedor' },
        { 
          key: 'montoNeto',
          class: 'text-right',
        },
        { 
          key: 'plazoPago',
          label: 'Plazo',
          class: 'text-right',
        },
        { 
          key: 'presupuestosInternos',
          label: 'Presup.',
          class: 'text-right',
        },
        { 
          key: 'ordenes-remitos',
          label: 'Órdenes/Remitos',
          class: 'text-right',
        },
        { 
          key: 'porcentaje',
          label: 'Participación',
          class: 'text-right',
        },
        { key: 'rubro' },
        { 
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      proveedoresGastos: [],
      proveedoresGastosFields: [
        // { 
        //   key: 'color',
        //   label: 'Ref'
        // },
        { key: 'proveedor' },
        { 
          key: 'montoNeto',
          class: 'text-right',
        },
        { 
          key: 'plazoPago',
          label: 'Plazo',
          class: 'text-right',
        },
        { 
          key: 'ordenes-remitos',
          label: 'Órdenes/Remitos',
          class: 'text-right',
        },
        { 
          key: 'porcentaje',
          label: 'Participación',
          class: 'text-right',
        },
        { key: 'rubro' },
        { 
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      resultadosOrdenesProveedores: [],
      resultadosOrdenesProveedoresFields: [
        { 
          key: 'color',
          label: 'Ref'
        },
        { key: 'proveedor' },
        { 
          key: 'valor',
          label: 'Cantidad',
          class: 'text-right',
        },
        { 
          key: 'pjeParticipacion',
          label: 'Pje Participación',
          class: 'text-right',
        },
      ]
    }
  },
  created() {
  },
  methods: {
    getIndicadores() {
    this.$store.dispatch('indicadoresProduccion/inicializar')
      .then(() => {
        this.$store.dispatch('indicadoresProduccion/getResultadosProveedoresCompras')
          .then(() => {
            this.proveedores = this.$store.getters['indicadoresProduccion/resultadosProveedoresCompras'];
          });

        this.$store.dispatch('indicadoresProduccion/getResultadosProveedoresGastos')
          .then(() => {
            this.proveedoresGastos = this.$store.getters['indicadoresProduccion/resultadosProveedoresGastos'];
          });

        this.$store.dispatch('indicadoresProduccion/getResultadosOrdenesProveedores')
          .then(() => {
            this.resultadosOrdenesProveedores = this.$store.getters['indicadoresProduccion/resultadosOrdenesProveedores'];
            let labels = this.$store.getters['indicadoresProduccion/resultadosOrdenesProveedoresLabels'];
            let colors = this.$store.getters['indicadoresProduccion/resultadosOrdenesProveedoresColors'];
            let data = this.$store.getters['indicadoresProduccion/resultadosOrdenesProveedoresData'];

            this.$refs.rankingOrdenes.render(labels, colors, data, false);
          });

        // if ((/true/i).test(this.accesoRankingPresupuestos)) {
        //   this.$refs.rankingPresupuestosProveedores.getResultados();
        // }

        this.$refs.indicadorRentabilidadOrdenes.getIndicador();
      });
    },
    getColor(item) {
      return item.color;
    },
    consultarCompras(proveedorId) {
      this.showSpinner();
      this.$store.dispatch('indicadoresProduccion/getResultadosProveedoresComprasDetalle', proveedorId)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptCompras = this.$store.getters['indicadoresProduccion/resultados'];

          if (rptCompras) {
            if (rptCompras.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Compras';
            let fileName = 'compras';

            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              // { titulo: 'Neto Gastos Producción', nombre: 'montoNetoCuentasProduccion', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Cuenta', nombre: 'proveedorCuenta', formato: '' },
              { titulo: 'Presup.Internos', nombre: 'presupuestosInternos', formato: '' }
            ];

            this.exportXLS(title, fileName, rptCompras, format);
            // this.exportXLSRptCompras(rptCompras);
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    consultarGastos(proveedorId) {
      this.showSpinner();
      this.$store.dispatch('indicadoresProduccion/getResultadosProveedoresGastosDetalle', proveedorId)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptCompras = this.$store.getters['indicadoresProduccion/resultados'];

          if (rptCompras) {
            if (rptCompras.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Gastos';
            let fileName = 'gastos';

            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Gastos', nombre: 'montoNetoCuentasGastos', formato: '' },
              { titulo: 'Neto Ordenes Internas', nombre: 'montoNetoOrdenesProveedoresInternas', formato: '' },
              { titulo: 'Neto Remitos Internos', nombre: 'montoNetoRemitosInternos', formato: '' },
              { titulo: 'Cuenta', nombre: 'proveedorCuenta', formato: '' }
            ];

            this.exportXLS(title, fileName, rptCompras, format);
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
  .dashboard-produccion {
    margin-bottom: 30px;
  }
  .dashboard-produccion .dashboard-chart > div {
    position: relative;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 10%;    
    /* top: 20px;
    padding-left: 20px;
    padding-right: 20px; */
  }
  .dashboard-produccion .dashboard-chart h4 {
    margin-bottom: 5px;
  }
  .dashboard-produccion .dashboard-chart p.description {
    font-size: 12px;
    font-style: italic;
  }
  .dashboard-produccion table {
    position: relative;
    top: 20px;
  }
  .dashboard-produccion table thead th {
    border-top: none;
  }

  .dashboard-produccion table td {
    vertical-align: middle;
  }
  .dashboard-produccion table tr:first-of-type td {
    border-top: none;
  }
  .dashboard-produccion table tr td {
    padding-bottom: 3px;
    padding-top: 3px;
  }
  .dashboard-produccion table td[aria-colindex="1"] {
    width: 30px;
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="1"] {
    width: calc(37% - 30px);
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="2"] {
    width: 15%;
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="3"] {
    width: 8%;
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="4"] {
    width: 8%;
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="5"],
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="6"] {
    width: 8%;
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="7"] {
    width: 16%;
  }
  .dashboard-produccion .table-dashboard.compras table td[aria-colindex="8"] {
    width: 30px;
  }

  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="1"] {
    width: calc(45% - 30px);
  }
  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="2"] {
    width: 15%;
  }
  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="3"] {
    width: 8%;
  }
  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="4"] {
    width: 8%;
  }
  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="5"] {
    width: 8%;
  }
  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="6"] {
    width: 16%;
  }
  .dashboard-produccion .table-dashboard.gastos table td[aria-colindex="7"] {
    width: 30px;
  }

  .dashboard-produccion table .color-reference {
    display: inline-block;
    position: relative;
    /* margin-right: 5px; */
    width: 24px; 
    height: 12px; 
    top: 2px;
  }

</style>